export class DisplaySmartTile {

    constructor(dashboardId: number, tileLabel: string, tileSQL: string, tileType: number, badgeValue: number) {
        this.dashboardID = dashboardId;
        this.tileLabel = tileLabel;
        this.tileType = tileType;
        this.badgeValue = badgeValue;
        this.tileSQL = tileSQL;
    }
    public dashboardID?: number | undefined;
    public tileLabel?: string | undefined;
    public tileSQL?: string | undefined;
    public tileType?: number | undefined;
    public badgeValue?: number | undefined;
    // public hasWildCards?: boolean | undefined;///
    // public hasCustomerIDWildCard?: boolean | undefined;///

    public get hasWildCards(): boolean {
        return this.tileSQL.indexOf('%') != -1;
    }

    public get hasCustomerIDWildCard(): boolean {
        return this.tileSQL.indexOf('%webtrackcustomerid%') != -1;
    }
}
